import { render } from "./ProducePage.vue?vue&type=template&id=47f1c17c"
import script from "./ProducePage.vue?vue&type=script&lang=js"
export * from "./ProducePage.vue?vue&type=script&lang=js"
script.render = render

export default script